var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyWorkingPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCBC00;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,36.5c-4.1,0-7.3,3.4-7.3,7.3c0,4.1,3.4,7.3,7.3,7.3s7.3-3.4,7.3-7.3C52.1,39.9,48.7,36.5,44.6,36.5z  M44.6,49.1L44.6,49.1c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3c2.9,0,5.3,2.4,5.3,5.3C49.9,46.8,47.5,49.1,44.6,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,36.5L44.6,36.5L44.6,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,43.2h-1.2v-1.9c0-0.6-0.5-1.1-1.1-1.1s-1,0.6-1,1.2v2.9c0,0.6,0.5,1.1,1.1,1.1h2.3 c0.6,0,1.1-0.5,1.1-1.1C47.7,43.7,47.1,43.2,46.5,43.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.1,43.2H57.6V39c0.6,0.5,1.4,0.4,1.9-0.1l3.5-4c0.5-0.6,0.5-1.4-0.1-1.9l0,0L45.5,17.8 c-0.5-0.5-1.3-0.5-1.8,0L26.1,32.9c-0.6,0.5-0.6,1.3-0.1,1.9l0,0l3.5,4c0.2,0.4,0.6,0.5,1,0.5s0.7-0.1,0.8-0.4v4.2H19.1 c-2.3,0-4.2,1.9-4.2,4.2v22.9c0,0.7,0.6,1.3,1.3,1.3l0,0h56.6c0.7,0,1.3-0.6,1.3-1.3l0,0V47.3C74.4,45.2,72.4,43.2,70.1,43.2z  M29,34.1l15.5-13.4L60,34l-1.7,1.9L45.5,24.8c-0.5-0.5-1.3-0.5-1.8,0l-13,11.1L29,34.1z M17.7,47.5c0-0.7,0.6-1.4,1.3-1.4h12.2 v22.9H17.7V47.5z M47.9,68.9h-6.7V59h6.7V68.9z M50.6,68.9V57.6c0-0.7-0.6-1.4-1.3-1.4h-9.6c-0.7,0-1.3,0.6-1.3,1.3l0,0v11.3H34 V36.6l10.5-8.8l10.4,8.8v32.2h-4.2V68.9z M71.5,68.9H57.6V46h12.5c0.7,0,1.3,0.6,1.3,1.4V68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,49.9c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4v-2.4 C23,50.6,22.4,49.9,21.6,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,49.9c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4v-2.4 C28.7,50.6,28.1,49.9,27.4,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,59.3c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4S23,64,23,63.1v-2.4C23,59.9,22.4,59.3,21.6,59.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,59.3c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4v-2.4 C28.7,59.9,28.1,59.3,27.4,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,49.9c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4v-2.4C63.3,50.6,62.7,49.9,62,49.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.5,49.9c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4v-2.4 C68.9,50.6,68.2,49.9,67.5,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,59.3c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4v-2.4C63.3,59.9,62.7,59.3,62,59.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.5,59.3c-0.7,0-1.4,0.6-1.4,1.4v2.4c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4v-2.4 C68.9,59.9,68.2,59.3,67.5,59.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWorkingPattern);
export default __webpack_public_path__ + "static/media/my-working-pattern.f94f550907f33391987c4e03b8df23a5.svg";
export { ForwardRef as ReactComponent };